import { h, Fragment } from "preact";
import { Edit } from "../../helpers/icons";
import StockStatus from "../stock-status/stock-status";

export default function ProductSetItemFormDrawer({ product, item, itemId }) {
  if (!product) return null;

  const { variant, quantity } = item;
  const variantUrl = `${product.helpers.url}?variant=${variant.id.replace("gid://shopify/ProductVariant/", "")}`;

  return (
    <div className="product-set-item__content">
      <div className="product-set-item-form-drawer__title">{product.title}</div>
      <div className="product-set-item-form-drawer__selected-options">
        {variant.selectedOptions.map((option) => option.value).join(" / ")}
      </div>
      <StockStatus
        productId={product.id}
        variantId={variant.id}
        quantityRequested={quantity}
        countryCode={window.theme.country}
      />
      <div className="product-set-item-form-drawer__quantity">
        {window.localeStrings.product.set_item_quantity.replace(
          "[count]",
          quantity,
        )}
      </div>
      <div className="product-set-item-form-drawer__footer">
        <price-snippet
          className="product-set-item-form-drawer__price"
          DYNAMIC
          PRICE={parseFloat(variant.price.amount)}
          COMPARE-AT-PRICE={parseFloat(variant.compareAtPrice?.amount || 0)}
          CURRENCY={variant.price.currencyCode}
        ></price-snippet>
        <button
          type="button"
          className="product-set-item-form-drawer__edit-option"
        >
          <quickview-trigger
            URL={variantUrl.toString()}
            SECTION-ID="quickview-set-item"
            SET-ITEM-ID={itemId}
            QUANTITY={item.quantity}
          ></quickview-trigger>
          <span className="link link--x-small">
            {window.localeStrings.product.edit_option}
          </span>
          <Edit />
        </button>
      </div>
    </div>
  );
}
